import type { GetToothTitleNumberParams } from '../config';

import { getDisplayToothNumber } from './getDisplayToothNumber';
import { isSupernumeraryTooth } from './isSupernumeraryTooth';

export const getToothTitleNumber = ({
  numeration,
  dentalNotationFormat,
}: GetToothTitleNumberParams): string => {
  const displayToothNumber = getDisplayToothNumber(
    numeration?.ISO ?? 0,
    dentalNotationFormat,
  ).toString();

  return displayToothNumber + (isSupernumeraryTooth(numeration) ? ' *' : '');
};
